var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "changelog-details" }, [
    !_vm.showingRelatedActions
      ? _c("div", { staticClass: "changelog-details__header" }, [
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  return _vm.hideDetails()
                }
              }
            },
            [
              _c("i", { staticClass: "fa fa-arrow-left" }),
              _vm._v("  "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "Back",
                    expression: "'Back'"
                  }
                ],
                staticClass: "back-label"
              })
            ]
          ),
          _vm._v(" "),
          _c("span", {
            staticClass: "changelog-details__date",
            domProps: { textContent: _vm._s(_vm.dateTime) }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.showingRelatedActions
      ? _c(
          "h2",
          {
            staticClass: "white m-b-20",
            attrs: { "data-testid": "changelog-details-statement" }
          },
          [_c("ChangeLogParts", { attrs: { parts: _vm.statement } })],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.changelog.action !== "Archive"
      ? _c(
          "div",
          [
            _c("legend", { staticClass: "p-l-0 m-b-5" }, [
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "Changes",
                    expression: "'Changes'"
                  }
                ]
              })
            ]),
            _vm._v(" "),
            _vm.changelog && _vm.showChangeLogDetails
              ? _c("ChangeLogDelta", {
                  attrs: { delta: _vm.changelog.diff, wide: _vm.wide }
                })
              : _vm._e()
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "m-t-10" },
      _vm._l(_vm.changelogRelatedActions, function(relatedAction) {
        return _c(
          "div",
          {
            key: relatedAction.transactionId,
            staticClass:
              "changelog-entry-list-item changelog-entry-list-item__related"
          },
          [
            _c(
              "div",
              {
                on: {
                  click: function($event) {
                    return _vm.showChangelogDetails(relatedAction)
                  }
                }
              },
              [_c("ChangeLogEntry", { attrs: { changelog: relatedAction } })],
              1
            ),
            _vm._v(" "),
            relatedAction.transactionId == _vm.currentRelactedActionOpen
              ? _c("ChangeLogDetails", {
                  attrs: {
                    changelog: relatedAction,
                    "showing-related-actions": true,
                    wide: _vm.wide
                  }
                })
              : _vm._e()
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }